import React from "react";
import { Mail } from "lucide-react";

/**
 * Support contact — single source of truth for the support address.
 * Renders `Support · Requests@Capittance.com` as a mailto link.
 * Props:
 *   - subject:   optional subject line
 *   - variant:   "footer" | "inline" | "button"
 *   - className: extra classes
 */
export const SUPPORT_EMAIL = "Requests@Capittance.com";

export default function SupportLink({ subject = "Capittance support request", variant = "footer", className = "" }) {
  const href = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`;
  if (variant === "button") {
    return (
      <a href={href} className={`btn btn-ghost btn-sm inline-flex items-center gap-1.5 ${className}`} data-testid="support-link">
        <Mail size={12}/> Contact support
      </a>
    );
  }
  if (variant === "inline") {
    return (
      <a href={href} className={`inline-flex items-center gap-1 text-xs underline hover:no-underline ${className}`} data-testid="support-link">
        <Mail size={11}/> {SUPPORT_EMAIL}
      </a>
    );
  }
  // footer
  return (
    <div className={`font-mono text-[10px] uppercase tracking-[0.18em] ${className}`} data-testid="support-link-footer">
      Support / billing / partnerships ·{" "}
      <a href={href} className="underline hover:no-underline" data-testid="support-link">{SUPPORT_EMAIL}</a>
    </div>
  );
}
